<template>
  <div>
    <el-row>
      <el-col>
        <form-section :title="$t('ConsentManager_Channels_Table')">
          <el-table
            :data="staticChannels"
            :border="true"
            :stripe="true"
            class="table-container"
            :show-header="true"
            data-qa="system-channels-table"
          >
            <el-table-column :label="$t('ConsentManager_Channels_Column_Name')">
              <template slot-scope="scope">
                <div data-qa="channel-name">
                  {{ $t(scope.row.label) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ConsentManager_Channels_Column_Key')">
              <template slot-scope="scope">
                <div data-qa="channel-key">
                  {{ $t(scope.row.key) }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </form-section>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <form-section :title="$t('ConsentManager_Custom_Channels_Table')">
          <template slot="controls">
            <el-button
              v-if="$can('SubscriptionPreference::Create')"
              @click="addRow"
              type="primary"
              plain
              icon="el-icon-circle-plus-outline"
              data-qa="add-channel-button"
            >
              {{ $t('ConsentManager_Custom_Channels_AddButton') }}
            </el-button>
          </template>
          <rest-list-editable
            :payload="fetchEndpoint"
            :add-endpoint="rowAddEndpoint"
            ref="rest-list"
            :filterable="false"
            data-qa="custom-channels-table"
          >
            <rest-list-column
              prop="name"
              :title="$t('ConsentManager_Channels_Column_Name')"
              :editable="true"
            >
              <template slot="input-edit" slot-scope="{ model }">
                <el-input
                  :placeholder="
                    $t('ConsentManager_Custom_Channels_NamePlaceholder')
                  "
                  v-model="model.name"
                  data-qa="custom-channel-name-input"
                />
              </template>
            </rest-list-column>
            <rest-list-column
              prop="key"
              :title="$t('ConsentManager_Channels_Column_Key')"
              :editable="true"
            >
              <template slot="input-edit" slot-scope="{ model }">
                {{ model.key }}
              </template>
            </rest-list-column>

            <rest-list-column-actions
              v-if="$can('SubscriptionPreference::Update')"
              :editable="true"
            >
              <template slot-scope="scope">
                <rest-list-action
                  icon="el-icon-view"
                  :title="$t('ConsentManager_Custom_Channels_ViewLogs')"
                  :click="() => viewLogs(scope.row)"
                />
                <rest-list-action
                  icon="el-icon-delete"
                  :title="$t('ConsentManager_Custom_Channels_Delete')"
                  :click="() => confirmDelete(scope.row)"
                />
              </template>
            </rest-list-column-actions>
          </rest-list-editable>
        </form-section>
      </el-col>
    </el-row>

    <delete-popup-warning
      :show-warning-dialog="showWarningDialog"
      :show-confirm-dialog="showConfirmDialog"
      entity-type="channel"
      :item-name="currentItem ? currentItem.name : ''"
      :warning-items="warningItems"
      @cancel="cancelDelete"
      @proceed="proceedToConfirm"
      @confirm="handleDeleteConfirm"
    />
  </div>
</template>

<script>
import { SubscriptionPreferenceChannelLabels } from '@/modules/settings/enum/SubscriptionPreferenceChannelEnum'
import RestListEditable from '@/common/components/rest/RestListEditable'
import { projectEndpoint } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import FormSection from '@/common/components/form/FormSection'
import deletePopupWarningUtils from '@/modules/consent-manager/utils/deletePopupWarningUtils'
import auditLogFilterUtils from '@/modules/consent-manager/utils/auditLogFilterUtils'
import DeletePopupWarning from '@/modules/consent-manager/components/DeletePopupWarning'
import RestListAction from '@/common/components/rest/RestListAction'

export default {
  name: 'ConsentManagerChannelsPage',
  mixins: [
    deletePopupWarningUtils.createDeleteMixin({
      componentRefName: 'rest-list'
    }),
    auditLogFilterUtils.createViewLogsMixin({
      channelType: auditLogFilterUtils.CHANNEL_TYPES.CHANNEL
    })
  ],
  components: {
    FormSection,
    RestListColumnActions,
    RestListColumn,
    RestListEditable,
    DeletePopupWarning,
    RestListAction
  },
  data() {
    return {
      SubscriptionPreferenceChannelLabels,
      customChannels: [],
      showWarningDialog: false,
      showConfirmDialog: false,
      currentChannel: null
    }
  },
  computed: {
    warningItems() {
      return [
        this.$t('ConsentManager_Channels_Warning_Remove_Consent_Data'),
        this.$t('ConsentManager_Channels_Warning_Break'),
        this.$t('ConsentManager_Channels_Warning_Remove_Preferences'),
        this.$t('ConsentManager_Channels_Warning_Incorrect_Data'),
        this.$t('ConsentManager_Channels_Warning_Data_Operations')
      ]
    },
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `consent-channels`,
        params: {
          sort: 'name'
        }
      })
    },
    rowAddEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `consent-channels`
      })
    },
    staticChannels() {
      return Object.keys(SubscriptionPreferenceChannelLabels).map(key => {
        return { key: key, label: SubscriptionPreferenceChannelLabels[key] }
      })
    }
  },
  methods: {
    addRow() {
      const model = {
        name: ''
      }
      this.$refs['rest-list'].addRow(model)
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `consent-channels/${row.id}`
      })
    },
    handleDeleteConfirm() {
      this.executeDelete(this.rowDeleteEndpoint)
    }
  }
}
</script>

<style scoped>
.table-container {
  border: 1px solid #dbdee7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/modules/consent-manager/pages/ConsentManagerChannelsPage.vue